<span
*ngIf="date"
[class.text-danger]="style && date.getTime() < today_start.getTime()"
[class.text-warning]="style && date.getTime() < nextWeek.getTime() && date.getTime() >= today_start.getTime()"
class="text-uppercase"
[title]="date|date: 'EEEE':undefined:currentLang">{{ date|date: ('GLOBAL.DATE_FORMAT.MD'|translate):timezone:currentLang }}</span>